module.exports = __webpack_public_path__ + "files/petit.72039e895ff2dbc79bbbcbccf0634d52.pdf";